import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavigationMenu, { NavigationItemOrCategory } from "../../../molecules/NavigationMenu/NavigationMenu";
import Route from "@/routes/Routes";
import { useAdminModeContext, useSelectedLinkContext } from "@/contexts";
import { navigateToSelectedChannelRoute } from "@/utils";
import { Button } from "@/components/ui/atoms/Button/Button";
import {
  faArrowTurnDown, faCalendar, faCircleInfo, faEnvelope, faFolder, faFolderPlus, faGear,
  faGrin, faHome, faStar, faSun, faUser, faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const AdminNavigationMenu = (): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();
  const { setIsAdminMode } = useAdminModeContext();
  
  const onClickBackToClassic = (): void => {
    setIsAdminMode(false);
    navigateToSelectedChannelRoute(selectedLink, Route.HOME);
  }

  const ADMIN_SETTINGS_GENERAL_NAVIGATION_ITEMS: NavigationItemOrCategory[] = [
    { 
      title: 'Informations sur l\'utilisateur', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faUser as IconProp} />,
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_GENERAL_USER_INFOS)
    },
    // { 
    //   title: 'Compte de l\'utilisateur', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_GENERAL_ACCOUNT_INFOS) 
    // },
  ];
  
  const ADMIN_SETTINGS_APPLICATIONS_NAVIGATION_ITEMS: NavigationItemOrCategory[] = [
    { 
      title: 'Communiquer', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faEnvelope as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_APPLICATION_COMMUNICATE) 
    },
    // { 
    //   title: 'Gestion des contenus', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_APPLICATION_CONTENT) 
    // },
    // { 
    //   title: 'Gestion du fil d\'actualité', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_APPLICATION_ACTU) 
    // },
    // { 
    //   title: 'Programme TV', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_APPLICATION_TV) 
    // },
    // { 
    //   title: 'Gestion des espaces', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_APPLICATION_SPACES) 
    // },
  ];
  
  const ADMIN_SETTINGS_TABLET_NAVIGATION_ITEMS: NavigationItemOrCategory[] = [
    { 
      title: 'Affichage & Diaporama', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faSun as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_TABLET_DISPLAY) 
    },
    { 
      title: 'Son', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faVolumeUp as IconProp} />,
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_TABLET_SOUND) 
    },
    // { 
    //   title: 'Système', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_TABLET_SYSTEM) 
    // },
    // { 
    //   title: 'Accessibilité', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_TABLET_ACCESSIBILITY) 
    // },
    // { 
    //   title: 'Avancés', 
    //   icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faPeopleArrows} />, 
    //   navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_SETTINGS_TABLET_ADVANCED) 
    // },
  ];
  
  const ADMIN_SETTINGS_NAVIGATION_ITEMS: NavigationItemOrCategory[] = [
    { 
      title: 'Général', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faCircleInfo as IconProp} />, 
      content: ADMIN_SETTINGS_GENERAL_NAVIGATION_ITEMS 
    },
    { 
      title: 'Applications de la tablette', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faUser as IconProp} />, 
      content: ADMIN_SETTINGS_APPLICATIONS_NAVIGATION_ITEMS 
    },
    { 
      title: 'Tablette de l\'utilisateur', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faFolderPlus as IconProp} />,
      content: ADMIN_SETTINGS_TABLET_NAVIGATION_ITEMS 
    },
  ];
  
  const ADMIN_NAVIGATION_ITEMS: NavigationItemOrCategory[] = [
    { 
      title: 'Accueil', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faHome as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN) 
    },
    { 
      title: 'Contacts', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faEnvelope as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_CONTACTS) 
    },
    { 
      title: 'Messages', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faEnvelope as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_MESSAGES) 
    },
    { 
      title: 'Agenda', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faCalendar as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_ORGANIZER) 
    },
    { 
      title: 'Classeur', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faFolder as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_WORKBOOK) 
    },
    { 
      title: 'Favoris', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faStar as IconProp} />, 
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_BOOKMARKS) 
    },
    { 
      title: 'Applications', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faGrin as IconProp} />,
      navigate: () => navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_APPLICATIONS) 
    },
    { 
      title: 'Réglages', 
      icon: <FontAwesomeIcon className="text-admin-blue-300" icon={faGear as IconProp} />, 
      content: ADMIN_SETTINGS_NAVIGATION_ITEMS 
    },
  ];

  const backToClassic: JSX.Element = (
    <Button variant="text" onClick={onClickBackToClassic}>
      <FontAwesomeIcon icon={faArrowTurnDown as IconProp} />
      Retour au mode classique
    </Button>
  );

  return <NavigationMenu navigationItems={ADMIN_NAVIGATION_ITEMS} footerAction={backToClassic} />;
}

export default AdminNavigationMenu;